import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-mjesec',
  templateUrl: './modal-mjesec.component.html',
  styleUrls: ['./modal-mjesec.component.scss'],
  standalone: false
})
export class ModalMjesecComponent implements OnInit {
  @Input() updateInputValue = new EventEmitter();
  context = localStorage.getItem('userContext');
  parsedContext = JSON.parse(this.context);

  constructor(private bsModalRef: BsModalRef) { }

  reportForm: UntypedFormGroup;

  ngOnInit(): void { }

  onSubmit() {
    if (this.reportForm.valid) {
      this.updateInputValue.emit(this.reportForm.value);
      this.closeModal();
    } else {
      this.reportForm.markAllAsTouched();
    }
  }
  closeModal() {
    this.bsModalRef.hide();
  }

}
